<template>
<section id="highThcHarvests">
  <section v-for="(thisSection,index) in value" :key="'thc' + index" data-autoslide="5000">
    <div
      class="sl-block"
      data-block-type="text"
      style="width: 100%; left: 29px; top: 84px; height: auto"
    >
      <div
        class="sl-block-content"
        data-placeholder-tag="h2"
        data-placeholder-text="Title Text"
        style="text-align: left; z-index: 10"
        dir="ui"
      >
        <h2 style="text-align: center; font-family: Poppins">Superior THC and Terps</h2>
      </div>
    </div>

    <div
      class="sl-block theme--dark"
      data-block-type="table"
      style="
        height: auto;
        min-width: 120px;
        width: 100%;
        left: 29px;
        top: 175.5px;
        min-height: 550px;
        display: flex;
        justify-content: center;
        align-items: center;
      "
    >
      <overview-chart v-model="value[index]" :canvasId="'thcChart1' + index" />
    </div>
  </section>
  </section>
</template>

<script>
import Trimaster from "@/plugins/servers/trimaster.js";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import OverviewChart from "./OverviewChart.vue";

export default {
  name: "",
  props: ["value"],
  components: { OverviewChart },
  beforeMount() {
    if (navigator.userAgent.indexOf("Silk") > 0) {
      this.gifUrl = "/img/presentationbackgrounds/harvestTime.gif";
    } else {
      this.videoUrl = "/img/presentationbackgrounds/harvestTime.mp4";
    }
    this.refresh();
  },
  mounted() {},
  data() {
    return {
      moment: moment,
      harvestSchedule: [],
      gifUrl: null,
      videoUrl: null,
    };
  },

  computed: {
    ...mapGetters(["getUser"]),
  },
  watch: {
    value(newVal, oldVal) {
      this.refresh();
    },
  },
  methods: {
    refresh() {},
  },
};
</script>
<style>
</style>

